import rootReducer from "../reducers";
import { configureStore } from "@reduxjs/toolkit";
import {
	createStateSyncMiddleware,
	initMessageListener,
} from "redux-state-sync";
import alertMiddleware from "../components/Alert/alertMiddleware";

const store = configureStore({
	reducer: rootReducer,
	middleware: (getDefaultMiddleware) =>
		getDefaultMiddleware()
			.concat(createStateSyncMiddleware({}) as any) // state sync across multiple tabs
			.concat(alertMiddleware),
});

initMessageListener(store);

export default store;

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
